<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="恢复维保"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="350px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item
          label="下次保养时间："
          class="label-with-six-word mr0"
          label-width="98px"
          prop="nextMaintainDate"
        >
          <el-date-picker
            v-model="form.nextMaintainDate"
            type="date"
            size="mini"
            prefix-icon=" "
            placeholder="下次保养时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { startMaintain } from "@/api/ElevatorManagement";
export default {
  data() {
    return {
      form: {
        nextMaintainDate: "",
      },
      rules: {
        nextMaintainDate: [
          {
            required: true,
            message: "请选择下次保养日期",
            trigger: "blur",
          },
        ],
      },
      loadBtn: false,
    };
  },
  props: {
    editData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const queryData = { ...this.form };
          queryData.liftId = this.editData.id;
          const res = await startMaintain(queryData);
          if (res.code === 200) {
            this.$message.success("在保成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/ElevatorManagement/components/StartMaintain.vue